import * as Yup from "yup";

export const validationSchemaCar = Yup.object().shape({
  name: Yup.string().required("Make is required"),
  model: Yup.string().required("Model is required"),
  registrationType: Yup.string().required("Registration Type is required"),
  ownerSerial: Yup.string().required("Owner Serial is required"),
  registrationExpiryDate: Yup.mixed().required(
    "Registration Expiry Date is required"
  ),
  insuranceExpiryDate: Yup.mixed().required(
    "Insurance Expiry Date is required"
  ),
  registrationDate: Yup.mixed().required("Registration Date is required"),
  yearOfManufacture: Yup.mixed().required("Year of Manufacture is required"),
  variant: Yup.string().required("Variant is required"),
  color: Yup.string().required("Color is required"),
  fuelType: Yup.string().required("Fuel Type is required"),
  kmsDriven: Yup.mixed()
    .test("isNumber", "Kilometres Driven should be a number", (value) => {
      if (value === null) {
        return false;
      }

      return Number.isInteger(parseInt(value));
    })
    .required("Kilometres Driven is required"),
  price: Yup.mixed()
    .test("isNumber", "Price should be a number", (value) => {
      if (value === null) {
        return false;
      }

      return Number.isInteger(parseInt(value));
    })
    .required("Price is required"),
  chassisNumber: Yup.string().required("Chassis Number is required"),
  inventoryType: Yup.string().required("Inventory Type is required"),
  transmission: Yup.string().required("Transmission is required"),
});

export const validationSchemaDealer = Yup.object().shape({
  dealerName: Yup.string().required("Dealer Name is required"),
  dealerContact: Yup.string().required("Dealer Contact is required"),
  dealerEmail: Yup.string()
    .email("Invalid email address")
    .required("Dealer Email is required"),
  dealerAddress: Yup.string().required("Dealer Address is required"),
});

export const validationSchemaOwner = Yup.object().shape({
  ownerAddress: Yup.string().required("Owner Address is required"),
  ownerName: Yup.string().required("Owner Name is required"),
  ownerContact: Yup.string().required("Owner Contact is required"),
  ownerEmail: Yup.string()
    .email("Invalid email address")
    .required("Owner Email is required"),
});

export const validationSchemaImages = Yup.object().shape({
  image: Yup.array().required("Images are required"),
});
